import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MessageSquareText } from "lucide-react";
import { http } from "@/lib/api";

export const MessagesLink = () => {
  const [n, setN] = useState(0);
  const loc = useLocation();
  useEffect(() => {
    const load = () => http.get("/coach-chat/unread").then((r) => setN(r.data.unread)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    window.addEventListener("coach-chat-seen", load);
    return () => { clearInterval(t); window.removeEventListener("coach-chat-seen", load); };
  }, [loc.pathname]);
  return (
    <NavLink to="/messages" data-testid="nav-messages" aria-label="Messages"
      className={({ isActive }) => `relative p-2 rounded-full transition-colors ${isActive ? "bg-[#2C4A3E] text-white" : "text-[#2C4A3E] hover:bg-[#F1EADB]"}`}>
      <MessageSquareText className="w-5 h-5" />
      {n > 0 && <span data-testid="nav-messages-unread" className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#C87D53] text-white text-[10px] grid place-items-center">{n > 99 ? "99+" : n}</span>}
    </NavLink>
  );
};
